import { ModalWindow, JsonViewer, RefSerializer, Button, Table, UnorderedList } from "@tblabs/truffle";
import { Device } from "../Services/Device";
import { IoStateViewer } from "../Pages/Shell/IoStateViewer";


export class DeviceProfileWindow extends ModalWindow
{
    constructor(device: Device)
    {
        super(`🖼️ ${device.Id} Profile`, true, true, true);
        this.WidthPercent(86);

        this.AddContent(
            new Table([],
                [
                    ["Id", device.Id],
                    ["Version", device.Version ?? "3.x.x or lower"],
                    ["Connection", device.ConnectionStatus.value + ", hotspot: " + (device.Hotspot.Name || "?") + " (" + device.Hotspot.Type + "), local IP: " + device.Config.localIp],
                    ["Password", device.Password.value],
                    ["Watchers", device.Watchers.Count.toString()],
                    ["Config", new JsonViewer(RefSerializer.Flatenize(device.Config), "Full config", { foldAll: true, openLinkButton: "" })],
                    ["Stats", new JsonViewer(RefSerializer.Flatenize(device.Stats), undefined, { foldAll: true })],
                    ["Record", new JsonViewer(RefSerializer.Flatenize(device.Record), undefined, { foldAll: true })],
                    ["Picture", device.PictureInfo.value],
                    ["Malfunctions", device.Malfunctions.length > 0 ? new UnorderedList(device.Malfunctions) : "No malfunctions"],
                    ["IO", device.IoState ? new IoStateViewer().Refresh(device.IoState) : "No IO state"],
                ]).Class("uk-table uk-table-small uk-table-striped"),
        );
        this.AddToFooter(
            new Button("Close", () => this.CloseWindow())
        );

        this.OpenWindow();
    }
}
